<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-01 17:05:47
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>文章管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="标题" prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-cascader
                style="margin-right: auto"
                :props="cateProps"
                :show-all-levels="false"
                v-model="ruleForm1.type"
                :options="cageryList"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="上传图片" prop="img">
              <el-upload
                style="margin-right: auto"
                list-type="picture-card"
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="deader"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :multiple="true"
                :file-list="ruleForm1.img"
                :limit="1"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="短简介" prop="memo">
              <el-input
                type="textarea"
                v-model="ruleForm1.memo"
                placeholder="请输入短简介"
              ></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="memo1">
              <el-upload
                class="avatar-uploader-quiil"
                :action="uploadUrl"
                :headers="deader"
                :show-file-list="false"
                :on-success="uploadSuccess1"
                :on-error="uploadError"
                :before-upload="beforeUpload"
              >
              </el-upload>
              <quill-editor
                v-model="ruleForm1.memo1"
                ref="myQuillEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @change="onEditorChange($event)"
                @ready="onEditorReady($event)"
              />
            </el-form-item>
            <el-form-item style="margin-top: 190px">
              <el-button
                @click="resetForm1('ruleForm')"
                style="margin-left: 50px"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    system,
    quillEditor,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增文章",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      selectData: [],
      ruleForm1: {
        name: "",
        type: "",
        img: [],
        memo: "",
        memo1: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
        memo1: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      editId: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      cageryList: [],
      content: "",
      //编辑器配置项生成 [可设置于data(){return{}}中]
      editorOption: {
        theme: "snow", //用于指定富文本主题
        modules: {
          toolbar: {
            container: [
              //该数组中的内容可以根据实际项目情况进行筛选，不需要展示的直接删除配置即可
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              [{ script: "sub" }, { script: "super" }], // 上标/下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              [{ direction: "rtl" }], // 文本方向
              [
                {
                  size: ["small", false, "large", "huge"],
                },
              ], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ font: ["songti"] }], // 字体种类
              [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              ["image", "video"], // 链接、图片、视频
            ],
            handlers: {
              image: function (value) {
                if (value) {
                  // 调用element的图片上传组件
                  document
                    .querySelector(".avatar-uploader-quiil input")
                    .click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
        placeholder: "请输入正文", //默认的编辑器提示文字
      },
      uploadUrl: "",
    };
  },
  created: function () {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    this.getList1();
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑文章";
      this.getDetail();
    }
  },
  methods: {
    handleChange(val) {
      this.ruleForm1.type = val[val.length - 1];
    },
    getList1() {
      let param = {
        page: 1,
        pageSize: 1000,
      };
      this.$axios
        .post(`/admapi/article/categorylist`, param)
        .then(({ data }) => {
          this.cageryList = data;
        })
        .catch()
        .finally();
    },
    goBack() {
      this.$router.go(-1);
    },
    handleAvatarSuccess(res, file) {
      let obj = {};
      obj.url = res.data;
      this.ruleForm1.img.push(obj);
    },
    handleRemove(file, fileList) {
      this.ruleForm1.img = fileList || [];
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm1.name.length > 100) {
            this.$message({
              message: "标题最多输入100字",
              type: "warning",
            });
            return;
          }
          let list = this.ruleForm1.img;
          let arr = [];
          for (var i = 0; i < list.length; i++) {
            let obj = {
              url: list[i].url,
            };
            arr.push(obj);
          }
          let param = {
            title: this.ruleForm1.name,
            articleUrlList: arr,
            categoryId: this.ruleForm1.type,
            detail: this.ruleForm1.memo1,
            brief: this.ruleForm1.memo,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/article/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/article/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.editId = "";
                this.ruleForm1.name = "";
                this.ruleForm1.type = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.memo1 = "";
                this.ruleForm1.img = [];
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/article/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.ruleForm1.name = data.title;
          this.ruleForm1.type = data.categoryId;
          this.selectData = [data.categoryId];
          this.ruleForm1.memo = data.brief;
          this.ruleForm1.memo1 = data.detail;
          let arr = data.articleUrlList;
          for (var i = 0; i < arr.length; i++) {
            this.ruleForm1.img.push({
              url: arr[i].url,
            });
          }
        })
        .catch()
        .finally();
    },
    // 富文本
    // 失去焦点事件
    onEditorBlur(quill) {},
    // 获得焦点事件
    onEditorFocus(quill) {},
    // 准备富文本编辑器
    onEditorReady(quill) {},
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      this.ruleForm1.memo1 = html;
    },
    uploadSuccess1(res, file) {
      // console.log(res)
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, "image", res.data);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败！");
      }
      this.quillUpdateImg = false;
    },

    // 富文本图片上传失败
    uploadError(ee) {
      console.log(ee);
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },

    // 富文本图片上传前
    beforeUpload(file) {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.quill-editor {
  width: 800px;
  height: 500px;
}
</style>
<style>
.editor {
  line-height: normal !important;
  height: 800px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>
